<template>
  <div class="container">
    <div class="row">
      <div class="col">
        <div class="input-group mb-3">
          <input type="text" ref="ean" autofocus class="form-control" placeholder="input EAN code" aria-label="EAN" aria-describedby="button-addon2" v-model="scaned" v-on:keyup.13="getInfo($event)">
          <div class="input-group-append">
            <button class="btn btn-secondary" type="button" id="button-addon2" v-on:click="getInfo($event)">Get product</button>
          </div>
        </div>
      </div>
    </div>
    <ProductView @setFocus="setFocus()"/>
  </div>
</template>

<script>
  import ProductView from '@/components/ProductView'
  import { mapMutations, mapActions } from 'vuex'

  export default {
    name: 'ProductFormEan',

    components: {
      ProductView
    },

    data () {
      return {
        scaned: ''
      }
    },

    mounted () {
      this.setFocus()
    },

    methods: {
      ...mapMutations(['updateScaned']),
      ...mapActions(['getProduct']),
      getInfo (e) {
        this.$store.commit('updateScaned', {scaned: this.scaned})
        this.$store.dispatch('getProduct')
        this.setFocus()
      },
      setFocus () {
        this.scaned = ''
        this.$refs.ean.focus()
        // console.log(this.$refs.ean)
      }
    }
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/ProductFormEan.vue